<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12" v-if="content">
        <exercise-logic-multiple
          exCollection="fourCornersClientExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="true"
          :projectShared="false"
          :pid="true"
          :eid="$route.params.eid"
          :synced="false"
          :saveState="saveState"
        >
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="1"
                  @click="navigateTo('client')"
                  >Client</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="2"
                  @click="navigateTo('customer')"
                  >Customer</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="3"
                  @click="navigateTo('context')"
                  >Context</v-stepper-step
                >
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="false"
                  step="4"
                  @click="navigateTo('competition')"
                  >Competition</v-stepper-step
                >
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <h2
                        class="headline"
                        v-text="content.exercise_four_client.step1.title"
                      ></h2>
                    </v-col>

                    <v-col cols="8" class="">
                      <p
                        v-for="(item, index) in content.exercise_four_client
                          .step1.description"
                        :key="index"
                        v-text="item"
                      />
                    </v-col>
                  </v-row>
                  <!-- loop through questions from language file -->
                  <v-row v-if="doc">
                    <v-col cols="12" offset="0">
                      <h2 class="headline">Defining the brief</h2>
                    </v-col>
                    <v-col cols="12" offset="0">
                      <v-row>
                        <v-col
                          v-for="item in content.exercise_four_client.questions.slice(
                            0,
                            2
                          )"
                          :key="item.name"
                          :cols="item.width"
                        >
                          <v-card>
                            <v-card-text>
                              <unit-items
                                v-model="doc.matrix[item.key]"
                                :name="item.name"
                                :title="item.title"
                                @autosave="doAutoSave"
                              ></unit-items>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" offset="0">
                      <h2 class="headline">Today and Tommorrow</h2>
                    </v-col>
                  </v-row>
                  <v-col cols="12" offset="0">
                    <v-row>
                      <v-col cols="6">
                        <unit-items-top-body
                          v-model="doc.matrix.q3"
                          :limit="20"
                          name="col1"
                          num=""
                          title="3) Where are you now?"
                          description=""
                          color="amber"
                          bgColor="#494949"
                          svg="wing-left-new@2x.png"
                          :reverse="false"
                          @autosave="doAutoSave"
                        >
                        </unit-items-top-body>
                      </v-col>
                      <v-col cols="6">
                        <unit-items-top-body
                          v-model="doc.matrix.q4"
                          :limit="20"
                          name="col2"
                          num=""
                          title="4) Where do you want to go?"
                          description=""
                          color="amber"
                          bgColor="#494949"
                          svg="wing-right-new@2x.png"
                          :reverse="true"
                          @autosave="doAutoSave"
                        >
                        </unit-items-top-body>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" offset="0">
                    <h2 class="headline">Strengths and Weaknesses</h2>
                  </v-col>
                  <v-col cols="12" offset="0">
                    <v-row>
                      <v-col
                        v-for="item in content.exercise_four_client.questions.slice(
                          4,
                          12
                        )"
                        :key="item.name"
                        :cols="item.width"
                      >
                        <v-card>
                          <v-card-text>
                            <unit-items
                              v-model="doc.matrix[item.key]"
                              :name="item.name"
                              :title="item.title"
                              @autosave="doAutoSave"
                            ></unit-items>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>

                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    :list="`four-corners`"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="saveExercise(false)"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title class="headline">
          {{ $t('exercise_four_client.saved.title') }}</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-else>
        <v-card-title class="headline">{{
          $t('exercise_functionality.saved.title')
        }}</v-card-title>

        <v-card-actions>
          <v-btn
            color="white"
            top
            right
            absolute
            class="black--text"
            @click="dialog = false"
          >
            Close
          </v-btn>

          <v-btn
            class="grey lighten-3"
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn
            class="amber"
            :to="`/users/project/${this.$route.params.id}/four-corners`"
          >
            Back to List
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import { BottomNavigation } from '@/components/core'
import { ExerciseLogicMultiple } from '@/components/exercises'

import { UnitItems, UnitItemsTopBody } from '@/components/units'

export default {
  name: 'UserFourCornersClient',
  data() {
    return {
      e1: 1,
      content: null,
      saveState: false,
      autoSave: true,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: 'add',
      allItems: null,
      listName: '',
      doc: {
        title: '',
        matrix: {
          q1: [],
          q2: [],
          q3: [],
          q4: [],
          q5: [],
          q6: [],
          q7: [],
          q8: [],
          q9: [],
          q10: [],
          q11: [],
          q12: [],
          q13: [],
          q14: []
        },
        list: {},
        listNames: [],
        allItems: [],
        audienceAll: [],
        contentAll: []
      },
      listLength: 1,
      debug: false
    }
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    UnitItems,
    UnitItemsTopBody
  },
  watch: {
    // e1(val) {
    //   if (val === 3) {
    //     this.createList();
    //   }
    // },
  },
  computed: {
    ...mapState([
      'userProfile',
      'currentUser',
      'currentProject',
      'currentProjectModel'
    ])
  },

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`)
    const data = await response.json()
    this.content = data
  },

  mounted() {},

  methods: {
    nextStep() {
      this.e1++
    },
    prevStep() {
      this.e1--
    },
    onReady() {},
    onError() {
      console.log('error')
    },
    onSaved() {
      console.log('saved ex')
      this.dialogMode = ''
      this.dialog = true
    },
    onLoadedRef(refs) {
      console.log('loaded refs', refs)
    },
    onLoadedEx(items) {
      console.log('loaded exercises', items)
      if (items) {
        this.mergeArrays(items[0].doc)
      }
    },
    onModifyEx(items) {
      // console.log("modify exercises", items);
      this.exercises = [...items]
    },
    onSavedNext() {
      // this.nextStep();
      this.saveState = false
    },
    clone(obj) {
      Object.assign({}, obj)
    },
    navigateTo(slug) {
      this.$router.push(
        `/users/project/${this.$route.params.id}/${slug}/shared`
      )
    },
    mergeArrays(arr) {
      console.log('merge arrays', arr)
      Object.entries(arr).forEach(([outerKey, value]) => {
        if (typeof value !== 'object') {
          this.doc[outerKey] = value
        } else {
          Object.entries(value).forEach(([key, value]) => {
            this.doc[outerKey][key] = value
          })
        }
      })
    },

    closeDialog() {
      this.dialog = false
      this.dialogMode = ''
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log('doing autosave')
        this.saveState = true
      }
    },
    createList() {
      let items = []
      Object.values(this.doc.matrix).forEach(value => {
        value.forEach(x => {
          x.color = 'blue lighten-4'
          items.push(x)
        })
      })
      let itemsFromList = []
      Object.values(this.doc.list).forEach(value => {
        value.forEach(x => {
          itemsFromList.push(x)
        })
      })
      let all = []
      items.forEach(x => {
        if (!itemsFromList.some(y => y.title == x.title)) {
          all.push(x)
        }
      })
      this.doc.allItems = all
    }
  }
}
</script>

<style lang="scss"></style>
